import React, { useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import dotNetVideo from '../assets/video/dotnet.mp4';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const VideoPlayer = ({
    setPageHeader,
    urlData,
    api = '/textapi'
}) => {

    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [videoData, setVideoData] = useState();
    const [loading, setLoading] = useState(true);


    const getData = () => {
        setLoading(true);
        liracrypt.get(api, { ...searchParams, ...urlData })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setVideoData(data.data);
                    setLoading(false);
                }
            }).catch(err => {
                console.log(err);
                ApiErrorComp();
            })
    }

    useEffect(() => {
        if (setPageHeader) {
            setPageHeader('Video Player');
        };
        getData();
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            {
                loading ?
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} /> :
                    <video onContextMenu={(e) => {
                        e.preventDefault()
                    }} width="1000" height="600" controls controlsList="nodownload">
                        <source src={dotNetVideo} type="video/mp4" />
                    </video>
            }

        </div>
    )
};

export default VideoPlayer;